// ============================================
// CONFIG - Beneficios mostrados en las páginas de alianza
// ============================================
// Los 6 beneficios son idénticos en las 4 landings de partner. Los SVG se
// mantienen tal cual estaban en los componentes originales (atributos
// heterogéneos entre íconos: no se normalizan a propósito, para no cambiar
// el DOM renderizado).

import type { ReactNode } from 'react';

export interface BeneficioConfig {
  n: number;
  /** Líneas de texto del beneficio (1-2 líneas, una por <p>). */
  lines: string[];
  /** Línea final destacada en azul (solo el beneficio 1: 'GRATIS'). */
  highlight?: string;
  icon: ReactNode;
}

export const BENEFICIOS: BeneficioConfig[] = [
  {
    n: 1,
    lines: ['Boleta', 'electrónica'],
    highlight: 'GRATIS',
    icon: (
      <svg className="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg>
    ),
  },
  {
    n: 2,
    lines: ['Inteligencia', 'de precios'],
    icon: (
      <svg className="w-12 h-12 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
        <path d="M10 2C5.58 2 2 5.58 2 10s3.58 8 8 8c1.85 0 3.55-.63 4.9-1.69l5.4 5.39c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-5.39-5.4C17.37 13.55 18 11.85 18 10c0-4.42-3.58-8-8-8zm0 2c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm-.5 2v1.08c-.8.13-1.5.73-1.5 1.67 0 .83.67 1.5 1.5 1.5h1c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5.22-.5.5s.22.5.5.5h.5V13c0 .28.22.5.5.5s.5-.22.5-.5v-1.08c.8-.13 1.5-.73 1.5-1.67 0-.83-.67-1.5-1.5-1.5h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H10.5V6c0-.28-.22-.5-.5-.5s-.5.22-.5.5z" />
      </svg>
    ),
  },
  {
    n: 3,
    lines: ['Soporte', 'WhatsApp'],
    icon: (
      <svg className="w-12 h-12 text-blue-600" fill="currentColor" viewBox="0 0 448 512">
        <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
      </svg>
    ),
  },
  {
    n: 4,
    lines: ['Multi-', 'usuario'],
    icon: (
      <svg className="w-12 h-12 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
      </svg>
    ),
  },
  {
    n: 5,
    lines: ['Diseño para', 'almaceneros'],
    icon: (
      <svg className="w-12 h-12 text-blue-600" fill="currentColor" viewBox="0 0 640 512">
        <path d="M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z" />
      </svg>
    ),
  },
  {
    n: 6,
    lines: ['Versión', 'PRO *'],
    icon: (
      <svg className="w-12 h-12 text-blue-600" fill="currentColor" viewBox="0 0 576 512">
        <path d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z" />
      </svg>
    ),
  },
];
